import axios from 'axios';

import { formatAddresses } from './index';

export default function fetchAddresses(q: string) {
  return axios({
    url: 'https://api-adresse.data.gouv.fr/search',
    method: 'GET',
    params: { q }
  })
    .then(response => response.data)
    .then(formatAddresses);
}
